"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ELEMENT_PROPS = {
  Button: {
    primary: true
  }
};
var ELEMENT_TYPES = {
  span: /*#__PURE__*/_react["default"].createElement("span", null),
  p: /*#__PURE__*/_react["default"].createElement("p", null),
  a: /*#__PURE__*/_react["default"].createElement("a", null),
  Button: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, null)
};

var _default = function _default(_ref) {
  var linkAs = _ref.linkAs,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["linkAs", "title"]);
  return /*#__PURE__*/_react["default"].cloneElement(getLinkElement(linkAs), _objectSpread(_objectSpread({
    children: title
  }, getElementProps(linkAs)), rest));
};

exports["default"] = _default;

function getElementProps(linkAs) {
  return ELEMENT_PROPS[linkAs] || {};
}

function getLinkElement(linkAs) {
  return ELEMENT_TYPES[linkAs] || ELEMENT_TYPES.span;
}